import { ReactiveVue } from '@skinsoft/reactive-vue';
import { Component } from 'vue-property-decorator';

@Component({
    template: require('./online-status-indicator.html'),
})
export class OnlineStatusIndicator extends ReactiveVue {
    public onLine = true;

    private running = false;

    public created() {
        this.running = true;
        this.onFrame();
    }

    public beforeDestroy() {
        this.running = false;
    }

    private onFrame() {
        this.onLine = window.navigator.onLine;

        if (this.running) {
            requestAnimationFrame(this.onFrame);
        }
    }
}
